"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const useTabIndex = () => {
    const [tabIndex, setTabIndex] = (0, react_1.useState)(-1);
    const setTabIndexOnKeyUp = (0, react_1.useCallback)((event) => {
        if (event.key === 'Tab') {
            setTabIndex(0);
        }
    }, [setTabIndex]);
    (0, react_1.useEffect)(() => {
        return () => setTabIndex(-1);
    }, [setTabIndex]);
    return [tabIndex, { setTabIndexOnKeyUp, setTabIndex }];
};
exports.default = useTabIndex;
